// Domain
const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.genericComponents.layoutFooterModalComponent.';

const LAYOUT_MODAL_TITLE = `${DOMAIN}title`,
  LAYOUT_MODAL_CONTENT = `${DOMAIN}content`;

export { LAYOUT_MODAL_TITLE, LAYOUT_MODAL_CONTENT };
